import * as React from "react";
export function Sound(_a) {
    var url = _a.url;
    var audioElement = React.useRef(null);
    React.useEffect(function () {
        var play = function () {
            if (!audioElement.current) {
                return;
            }
            void audioElement.current.play();
        };
        play();
    }, [url]);
    if (!url) {
        return null;
    }
    return (React.createElement("audio", { autoPlay: true, controls: false, onEnded: function () {
            // Do nothing
        }, src: url, ref: audioElement }));
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicXVlc3RQbGF5LnNvdW5kLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicXVlc3RQbGF5LnNvdW5kLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEtBQUssS0FBSyxNQUFNLE9BQU8sQ0FBQztBQUUvQixNQUFNLFVBQVUsS0FBSyxDQUFDLEVBQStCO1FBQTdCLEdBQUcsU0FBQTtJQUN6QixJQUFNLFlBQVksR0FBRyxLQUFLLENBQUMsTUFBTSxDQUEwQixJQUFJLENBQUMsQ0FBQztJQUNqRSxLQUFLLENBQUMsU0FBUyxDQUFDO1FBQ2QsSUFBTSxJQUFJLEdBQUc7WUFDWCxJQUFJLENBQUMsWUFBWSxDQUFDLE9BQU8sRUFBRTtnQkFDekIsT0FBTzthQUNSO1lBQ0QsS0FBSyxZQUFZLENBQUMsT0FBTyxDQUFDLElBQUksRUFBRSxDQUFDO1FBQ25DLENBQUMsQ0FBQztRQUNGLElBQUksRUFBRSxDQUFDO0lBQ1QsQ0FBQyxFQUFFLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQztJQUVWLElBQUksQ0FBQyxHQUFHLEVBQUU7UUFDUixPQUFPLElBQUksQ0FBQztLQUNiO0lBQ0QsT0FBTyxDQUNMLCtCQUNFLFFBQVEsRUFBRSxJQUFJLEVBQ2QsUUFBUSxFQUFFLEtBQUssRUFDZixPQUFPLEVBQUU7WUFDUCxhQUFhO1FBQ2YsQ0FBQyxFQUNELEdBQUcsRUFBRSxHQUFHLEVBQ1IsR0FBRyxFQUFFLFlBQVksR0FDakIsQ0FDSCxDQUFDO0FBQ0osQ0FBQyJ9